import { z } from "zod"

import {
  powurOsAdderCategorySchema,
  powurOsAdderLenderCategorySchema,
} from "./adder-categories"
import { powurOsAdderPriceSchema } from "./adder-price"

export const powurOsAdderSchema = z.object({
  id: z.number().int(),
  title: z.string(),
  watts: z.number(),
  unit: z.any(),
  isVariable: z.boolean(),
  isInternal: z.boolean(),
  needsModuleCount: z.boolean(),
  isRacking: z.boolean(),
  isPermit: z.boolean(),
  isSiteSurvey: z.boolean(),
  isDesign: z.boolean(),
  isCustom: z.boolean(),
  isInterconnect: z.boolean(),
  isGroundMount: z.boolean(),
  isBaseCost: z.boolean(),
  lineType: z.number(),
  categoryId: z.number(),
  category: powurOsAdderCategorySchema,
  priceList: z.array(powurOsAdderPriceSchema),
  isEquipment: z.boolean(),
  isLabor: z.boolean(),
  relatedAdderId: z.nullable(z.number().int()),
  relatedAdder: z.nullable(z.unknown()),
  doesMountingTypeRequireInstaller: z.boolean(),
  isMPU: z.boolean(),
  isTurnKey: z.boolean(),
  lenderCategories: z.array(powurOsAdderLenderCategorySchema).optional(),
})
export type PowurOsAdder = z.infer<typeof powurOsAdderSchema>
